import type { AxiosResponse } from 'axios'

import { AdminApiError, adminClient } from '@/api/clients/admin-client'
import type { ApiResponse } from '@/shared/types/http'
import type {
  AdminIdentity,
  AdminLoginCredentials,
  AdminLoginResult
} from '@/shared/types/admin'

const createLoginUuid = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`
}

const requireData = <T>(response: AxiosResponse<ApiResponse<T>>): T => {
  if (response.data.data === undefined || response.data.data === null) {
    throw new AdminApiError('Admin 响应缺少数据', response.data.code)
  }

  return response.data.data
}

export const loginAdmin = async (
  credentials: AdminLoginCredentials
): Promise<AdminLoginResult> => {
  const response = await adminClient.post<ApiResponse<AdminLoginResult>>('/login', {
    username: credentials.username,
    password: credentials.password,
    uuid: createLoginUuid()
  })

  return requireData(response)
}

export const getAdminProfile = async (): Promise<AdminIdentity> => {
  const response = await adminClient.get<ApiResponse<AdminIdentity>>('/sys/user/info')
  return requireData(response)
}

export const logoutAdmin = async (): Promise<void> => {
  await adminClient.post<ApiResponse>('/logout')
}

export interface AdminPasswordChange {
  password: string
  newPassword: string
}

export const changeAdminPassword = async (payload: AdminPasswordChange): Promise<void> => {
  await adminClient.put<ApiResponse>('/sys/user/password', payload)
}
